'use client';
const parseSegmentQuery = (query)=>{
    const correctlyWrapped = query.startsWith('[') && query.endsWith(']');
    if (!correctlyWrapped) {
        return false;
    }
    const body = query.slice(1, -1);
    const [from, to] = body.replaceAll(' ', '').split(',');
    if (from && to) {
        return {
            from,
            to
        };
    }
    return false;
};

export { parseSegmentQuery };
//# sourceMappingURL=parseSegmentQuery.js.map
